<template>
  <modal name="medley-dialog" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true"
    @before-close="handleBeforeClose">
    <div style="text-align: left;">
      <p style="color: gray; border: 1px solid; display: inline;">PR</p>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeMedleyDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 1">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！</p>
        <p style="font-size: 140%;">選考と合わせて、<br>好条件の求人が多数掲載されている<br>ジョブメドレーへの登録もしておきましょう。</p>
        <br>
        <p style="font-size: 140%;">業界最大級の求人数から、自分のペースで職探しが可能。理想の職場がきっと見つかります。</p>
        <p style="font-size: 140%;color:red;">サービスご利用者満足度96%！</p>
        <br />
        <p style="font-size: 140%;">登録すると、事業所から直接スカウト<br>を受け取ることも可能に。</p>
        <p style="font-size: 140%;">今すぐ60秒で簡単無料登録！</p>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-medley-consult');">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/medley_yagish_logo.png" style="width:100%">
          </p>
        </div>

        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedMedley == false"
            style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
            @click="$eventHub.$emit('send-medley-consult');">無料登録する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSendedMedley == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMedleyDialog();">送信しました</el-button>
        </div>
        <br />
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 2">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/jigen_medley_yagish_logo.png" style="width:100%">
          </p>
        </div>
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a>
          <br />
          アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a
            href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">遷移先のサイトで働きたい</p>
        <p style="font-size: 140%;">アルバイトを探そう！</p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して求人受取や<br>会員登録を希望する
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
        <p style="font-size: 140%;">
          <el-checkbox v-model="isAgree"
            style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して求人受取や<br>会員登録を希望する</el-checkbox>
        </p>
        <br />
      </div>
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedJigen == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-jigen-consult');">普通のアルバイトを希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSendedJigen == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeMedleyDialog();">送信しました</el-button><br>
        <p style="font-size: 140%;">⬇︎看護師、歯科、介護、保育、リハビリ、<br>ヘルスケアなどの専門職</p>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedMedley == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-medley-consult');">専門職のアルバイトを希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSendedMedley == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeMedleyDialog();">送信しました</el-button>
        <br />
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <br />
        <br />
        <p style="font-size: 140%;">退職で困っている人は無料で相談に乗るよ！</p>
        <p style="font-size: 140%;">退職関係なら法律にも詳しいよ！</p>
      </div>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
          style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3uT6SV6', '_blank');"><span>無料で質問する</span></button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://apple.co/3GJbCBo', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://bit.ly/3O01VRv', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 3">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 140%;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の勤め先をご紹介します！</p>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">
            <img src="/static/renew_img/medley_adtop_yagish_logo.png" style="width:90%">
          </p>
        </div>
        <div style="display: inline-block;min-width: 100%;text-align:center;">
          <p style="font-size: 140%;">ご同意いただいた方には追って連絡がいき</p>
          <p style="font-size: 140%;">ますので、ご確認お願いいたします！</p>
        </div>
        <p>
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a>
          <br />
          アルバイトEXの<a href="https://arubaito-ex.jp/terms" target="_blank">利用規約</a>、<a
            href="https://arubaito-ex.jp/privacy" target="_blank">個人情報保護方針</a>
          <br />
          ㈱アド・トップの<a href="https://adtop-web.com/saiplus/agent/careerup/tos.html" target="_blank">利用規約</a>、<a
            href="https://adtop-web.com/privacypolicy.html" target="_blank">個人情報保護方針</a>
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">規約に同意して無料相談や<br>求人受取、会員登録を希望する
        </p>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="false">
        <p style="font-size: 140%;">
          <el-checkbox v-model="isAgree"
            style="-moz-transform:	scale(1.4);-webkit-transform:	scale(1.4);transform:		scale(1.4);">規約に同意して無料相談や<br>求人受取、会員登録を希望する</el-checkbox>
        </p>
        <br />
      </div>
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedAdtop == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;"
          @click="$eventHub.$emit('send-adtop-consult');">正社員希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSendedAdtop == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeMedleyDialog();">送信しました</el-button>
        <p style="font-size: 140%;">⬇︎看護師、歯科、介護、保育、リハビリ、<br>ヘルスケアなどの専門職</p>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedMedley == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 140%;"
          @click="$eventHub.$emit('send-medley-consult');">専門職のアルバイトを希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSendedMedley == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeMedleyDialog();">送信しました</el-button>
      </div>
      <br />
      <div class="text-center">
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedJigen == false"
          style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;"
          @click="$eventHub.$emit('send-jigen-consult');">時短やアルバイト希望</el-button>
        <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isSendedJigen == true"
          style="background-color:#0F9934;border-color:#0F9934;" @click="closeMedleyDialog();">送信しました</el-button>
        <br />
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p style="font-size: 140%;">退職で困っている人は無料で相談に乗るよ！</p>
        <p style="font-size: 140%;">退職関係なら法律にも詳しいよ！</p>
      </div>
      <div class="text-center">
        <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
          style="background-color:#0F9934;border-color:#0F9934;"
          onClick="window.open('https://bit.ly/3uT6SV6', '_blank');"><span>無料で質問する</span></button>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-if="$deviceLib.isApple">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://apple.co/3GJbCBo', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
      <div style="display: inline-block;min-width: 100%;text-align:center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 140%;">
          <img src="/static/renew_img/check_icon.png" style="width:40px">アプリをダウンロードしていつでも編集・PDFをメール送信できるように準備しよう！
        </p>
        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color:#0F9934;border-color:#0F9934;"
            onClick="window.open('https://bit.ly/3O01VRv', '_blank');"><span>ヤギッシュアプリを確認！</span></button>
        </div>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 4">
      <div style="text-align: center;">

        <!--企業ロゴ-->
        <div style="display: inline-block; min-width: 100%; text-align: center; padding: 10px;">
          <img src="/static/renew_img/medley_yagish_logo.jpeg" style="max-width: 100%;">
        </div>

        <p style="margin-bottom: 10px;">ダウンロードが完了しました！</p>
        <p style="margin-bottom: 10px;">選考と合わせて、好条件の医療介護系求人が掲載されているジョブメドレーへの登録もしてみてね！</p>

        <!--オススメリスト-->
        <div style="display: inline-block; min-width: 100%; text-align: center; margin-bottom: 20px;">
          <div
            style="text-align: left; margin-left: 0.5rem; font-size: 120%; font-weight: bold; line-height: 1.3; margin-bottom: 20px;">
            <div style="padding-bottom: 10px; display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;">医療系求人数業界No.1</p>
            </div>
            <div style="padding-bottom: 10px; display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;"><span
                  style="font-size: 80%;">自分のペースで職探しが可能</span><br>しつこい電話や催促もなし！</p>
            </div>
            <div style="display: flex; align-items: center;">
              <p
                style="display: block; background:#0F9934; width: 20px; height: 20px; border-radius: 50%; margin-right: 10px;">
              </p>
              <p style="font-size: 120%; font-weight: bold;"><span
                  style="font-size: 80%;">事業所から直接スカウトが届くかも？</span><br>今すぐ60秒で簡単無料登録！</p>
            </div>
          </div>
        </div>

        <!--登録ボタン-->
        <div>

          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedMedley == false"
            style="background-color: #E3165C; border-color: #E3165C; font-size: 120%; width: 100%;"
            @click="$eventHub.$emit('send-medley-consult');">登録をする</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSendedMedley == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMedleyDialog();">送信しました</el-button>
        </div>
      </div>
    </div>
    <div class="setting" v-else>

      <div class="setting-item" v-if="false">
        <p style="font-size: 16px; font-weight: bold; margin-bottom: 10px;text-align: center;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 16px; font-weight: bold;text-align: center;">さっそく転職活動をスタートしましょう！<br
            class="sp">好条件求人満載のおすすめサイトはココ！
        </p>

        <div style="text-align:center; background: #F7F7F7; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-medley-consult');">
          <p style="text-align: center;">
            <img src="/static/renew3_img/rt/job-medley-yagish-logo-20241119.png" alt="" style="width: 90%;">
          </p>

          <p style="font-size: 16px; font-weight: bold; color: rgb(227, 22, 92);">
            <img src="/static/renew3_img/carat_img/caratcheck_icon.svg"
              style="position: relative; height: 16px; top: -5px;">規約に同意して無料相談を希望する
          </p>
        </div>

        <div class="text-center">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedMedley == false"
            style="background: none; border: none; padding: 20px 0; margin-top: -20px; width: 100%;"
            @click="$eventHub.$emit('send-medley-consult');"><span
              style="font-size: 18px; font-weight: bold; margin-top: 0; display: block; width: 100%; background: rgb(227, 22, 92); border: rgb(227, 22, 92); padding: 20px; border-radius: 4px;">同意する</span></el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSendedMedley == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMedleyDialog();">送信しました</el-button>
          <br />
        </div>

        <p style="font-weight: bold; margin-bottom: 15px;"><span
            style="color:red;">【重要】</span>ご同意頂いた方に、ジョブメドレーよりご案内のメールを送付しますので、ご確認下さい。
        </p>

        <p style="font-size: 11px; font-weight: bold; line-height: 1.5; margin-bottom: 20px;text-align: center;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          株式会社メドレーの<a href="https://job-medley.com/rule/" target="_blank">利用規約</a>、<a
            href="https://job-medley.com/rule/" target="_blank">個人情報保護方針</a>を
          <br>確認してジョブメドレーに登録することになります。
        </p>
      </div>

      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 1rem; font-weight: bold;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">さっそく転職活動をスタートしましょう！<br>好条件求人満載のおすすめサイトはココ！</p>

        <div style="text-align:center;  padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="$eventHub.$emit('send-medley-consult');">
          <p style="display: inline-block;">
            <img src="/static/renew3_img/rt/job-medley-yagish-logo-20241119.png" alt="">
          </p>
        </div>
        <p style="font-weight: bold;"><span style="color:red;">【重要】</span>ご同意頂いた方に、ジョブメドレーより<br>ご案内のメールを送付しますので、ご確認下さい。
        </p>
        <br>

        <p style="font-size: 80%;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          株式会社メドレーの<a href="https://job-medley.com/rule/" target="_blank">利用規約</a>、<a
            href="https://job-medley.com/rule/" target="_blank">個人情報保護方針</a>を
          <br>確認してジョブメドレーに登録することになります。
        </p>
        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;">
          <el-checkbox v-model="isAgree"
            style="-moz-transform:scale(1.4);-webkit-transform:	scale(1.4);transform:scale(1.4);">各種規約に同意して無料登録する</el-checkbox>
        </p>

        <div class="text-center" style="padding:10px">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isSendedMedley == false"
            style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;"
            @click="$eventHub.$emit('send-medley-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-if="isSendedMedley == true" style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMedleyDialog();">送信しました</el-button>
          <br />
        </div>

      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import { emitRtDialogClosedWithoutSubmit, wrapMittPopupHandler } from '@/plugins/emitter'
export default {
  components: {
  },
  data: function () {
    return {
      isMypage: false,
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 4,
      isSendedJigen: false,
      isSendedMedley: false,
      isSendedAdtop: false,
      fullscreenLoading: false,
      clientId: 'medley_link',
      username: '',
      baite_title: 'バイト',
      isAgree: true,
      medleyID: 1,
      medleyPCLnks: {
        1: 'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2: 'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3: 'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5: 'https://job-medley.com/lp/dh/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6: 'https://job-medley.com/lp/da/18021/pc/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7: 'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      },
      medleySPLnks: {
        1: 'https://job-medley.com/lp/hh/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=hh_yagish',
        2: 'https://job-medley.com/lp/cw/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=cw_yagish',
        3: 'https://job-medley.com/lp/apo/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=apo_yagish',
        4: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        5: 'https://job-medley.com/lp/dh/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=dh_yagish',
        6: 'https://job-medley.com/lp/da/18021/sp/?utm_source=yagish&utm_medium=cpa&utm_campaign=da_yagish',
        7: 'https://job-medley.com/lp/ans/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=ans_yagish',
        8: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        9: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish',
        10: 'https://job-medley.com/lp/rehabilitation/chat/?utm_source=yagish&utm_medium=cpa&utm_campaign=rehabilitation_yagish'
      }
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openMedleyDialog: function (id, html, medleyID, permissionType, isMypage = false) {
      this.isMypage = isMypage
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.medleyID = medleyID
      this.permissionType = permissionType
      this.$modal.show('medley-dialog')
      this.clearLocalStorageConfirmVisible = false
      if (permissionType == 0) {
        if (this.formatid == 'rerekisho_part_time' ||
          this.formatid == 'rirekisho_part_time2') {
          this.permissionType = 2
        } else {
          this.permissionType = 3
        }
        this.permissionType = 4
      }

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'medley_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
    },
    closeMedleyDialog: function () {
      this.$modal.hide('medley-dialog')
      this.clearLocalStorageConfirmVisible = false
      // this.$router.push('/mypage')
    },
    handleBeforeClose: function (event) {
      if (!this.isSendedMedley && !this.isSendedJigen && !this.isSendedAdtop) {
        this.$eventHub.$emit('update_rt_condition', this.clientId, this.permissionType)
        emitRtDialogClosedWithoutSubmit()
      }
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendAdtopConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'medley_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.adtopPdfMail, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSendedAdtop = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '担当者からあなたに電話・メールでご連絡することがあります！',
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendMedleyConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }

      if (this.isSendedMedley) {
        return
      }
      if (this.permissionType < 5) {
        if (this.$deviceLib.isMobileDevice == 'SP') {
          window.open(this.medleySPLnks[this.medleyID], '_blank')
        } else {
          window.open(this.medleyPCLnks[this.medleyID], '_blank')
        }
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'medley_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendLinkMedley, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSendedMedley = true
          app.$globalVar.eventTag()
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendJigenConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      const jigen_url = 'https://arubaito-ex.jp/search?kw=&form_type=header_search&ref_code=oem_register_yagish_link&utm_source=register_yagish_link&utm_medium=oem'
      window.open(jigen_url, '_blank')
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'medley_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('is_mypage', this.isMypage ? 'true' : 'false')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendJigen, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSendedJigen = true
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$on('send-jigen-consult', this.sendJigenConsult)
    this.$eventHub.$on('send-medley-consult', this.sendMedleyConsult)
    // emitGlobalVarPopupDialog → mitt 直購読（GLOBAL_VAR_POPUP_EVENT_TYPES / emitter.js）
    this._mittGVPopup_openMedleyDialog = wrapMittPopupHandler(this, 'openMedleyDialog')
    this.$emitter.on('open-medley-dialog', this._mittGVPopup_openMedleyDialog)
    this.$eventHub.$on('popstate', this.closeMedleyDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-adtop-consult', this.sendAdtopConsult)
    this.$eventHub.$off('send-jigen-consult', this.sendJigenConsult)
    this.$eventHub.$off('send-medley-consult', this.sendMedleyConsult)
    this.$emitter.off('open-medley-dialog', this._mittGVPopup_openMedleyDialog)
    this.$eventHub.$off('popstate', this.closeMedleyDialog)
  }
}
</script>
